import Container from "./component/Container";
import Footer from "./component/Footer";
import Navbar from "./component/Navbar";

function App() {
  return (
    <div>
      <Navbar />

      <Container />

      <Footer />
    </div>
  );
}

export default App;
